import { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AppHeader({ title, subtitle }) {
  const [settings, setSettings] = useState({
    website_name: 'Vistara Verify',
    logo_url: null,
    logo_size: 40,
    show_title: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      // Try authenticated endpoint first
      const response = await axios.get(`${API}/settings`).catch(() => {
        // Fallback to public endpoint if auth fails
        return axios.get(`${API}/settings/public`);
      });
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to load settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const logoSize = settings.logo_size || 40;

  return (
    <div className="flex items-center gap-3">
      {settings.logo_url ? (
        <img
          src={`${BACKEND_URL}${settings.logo_url}`}
          alt="Logo"
          style={{ height: `${logoSize}px`, width: 'auto' }}
          className="object-contain"
        />
      ) : (
        <div 
          className="bg-amber-700 rounded-lg flex items-center justify-center"
          style={{ 
            width: `${logoSize}px`, 
            height: `${logoSize}px` 
          }}
        >
          <Shield 
            style={{ 
              width: `${logoSize * 0.6}px`, 
              height: `${logoSize * 0.6}px` 
            }} 
            className="text-white" 
          />
        </div>
      )}
      {settings.show_title && !loading && (
        <div>
          <h1 className="text-xl font-bold text-slate-900 tracking-tight">
            {title || settings.website_name}
          </h1>
          {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
        </div>
      )}
    </div>
  );
}
